import { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

function base(size = 24, extra?: SVGProps<SVGSVGElement>): SVGProps<SVGSVGElement> {
  return {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...extra,
  };
}

export function LockIcon({ size = 24, ...props }: IconProps) {
  return (
    <svg {...base(size)} strokeWidth={2.5} {...props}>
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}

export function UserIcon({ size = 24, ...props }: IconProps) {
  return (
    <svg {...base(size)} strokeWidth={2} {...props}>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

export function AlertCircleIcon({ size = 24, ...props }: IconProps) {
  return (
    <svg {...base(size)} strokeWidth={2.5} {...props}>
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  );
}

export function ArrowRightIcon({ size = 24, ...props }: IconProps) {
  return (
    <svg {...base(size)} strokeWidth={2.5} {...props}>
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  );
}

export function WarningQueueIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="44" height="44" viewBox="0 0 118 105" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_0_41)">
        <path d="M116.975 88.6521C100.23 61.7458 85.7042 32.2583 68.3036 5.85667C66.1595 2.60458 64.6883 0.842917 60.6068 0H57.4023C54.4629 0.924583 51.7419 2.05625 50.2882 4.98167C35.4861 31.2404 19.1546 56.6708 4.33508 82.9092C2.79982 85.6304 0.332318 89.2121 0.0526488 92.3242C-0.567867 99.2046 4.43705 104.323 11.085 104.974C11.8454 105.047 12.6494 104.921 13.4156 104.974H107.221C108.174 104.539 109.115 104.673 110.213 104.323C114.076 103.098 116.972 99.4729 118 95.6404V91.8487L116.975 88.6462V88.6521ZM57.6266 94.4008C49.458 93.2196 49.5191 80.9287 57.3295 79.6775C69.1717 77.7758 69.3756 96.1012 57.6266 94.4008ZM66.4333 32.8008C65.8128 44.7883 63.6016 57.1871 62.917 69.23C62.3868 72.8408 56.1409 73.0596 55.1446 69.7637L51.2671 30.765C51.1214 27.2446 53.7753 23.38 57.3295 22.8112C64.2979 21.6971 66.7479 26.6992 66.4333 32.7979V32.8008Z" fill="#2033EF" />
      </g>
      <defs>
        <clipPath id="clip0_0_41">
          <rect width="118" height="105" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function QueuePlusCircleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 91 91" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <circle cx="45.4889" cy="45.4889" r="45.4889" fill="#FEC822" />
      <path d="M40.4293 65.0469V26.0469H50.2895V65.0469H40.4293ZM25.8594 50.477V40.6168H64.8594V50.477H25.8594Z" fill="black" />
    </svg>
  );
}

export function QueueMinusCircleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 91 91" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <circle cx="45.4889" cy="45.4889" r="45.4889" fill="#FEC822" />
      <rect x="26" y="42" width="39" height="9" fill="black" />
    </svg>
  );
}

export function QueueSuccessIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 60 62" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <ellipse cx="30.4674" cy="31.5" rx="24.0299" ry="24.5" fill="white" />
      <path d="M31.3311 1.5L31.5029 1.54102C31.7293 1.59513 32.0009 1.62399 32.3682 1.64746C32.6944 1.6683 33.1627 1.68701 33.5898 1.73926H33.5908C55.8343 4.47059 66.1989 31.6819 51.8105 49.1436C35.7474 68.6376 4.87718 58.9299 1.74707 34.1807L1.74121 34.1318L1.51758 31.7275L1.50879 31.6309L1.51172 31.5352C1.52258 31.2299 1.5156 30.9164 1.50781 30.5449C1.50037 30.1899 1.49235 29.7806 1.5127 29.3652L1.55566 28.6602C2.62002 13.9091 14.1089 2.29149 28.7549 1.50195L28.7949 1.5H31.3311ZM44.877 19.7832L44.8779 19.7842C44.5969 19.8123 44.2169 19.9501 43.8975 20.1494L25.5986 37.5107L24.4873 38.5635L23.457 37.4316L16.5557 29.8545L16.5098 29.8037L16.4678 29.749C15.893 28.9883 15.1469 28.5625 14.4922 28.4736C13.8997 28.3934 13.272 28.5657 12.707 29.2568L12.7061 29.2559C12.1739 29.9073 12.1107 30.4852 12.25 31.043C12.3895 31.6016 12.7611 32.2211 13.3311 32.8281L13.5879 33.0869L13.6201 33.1182L13.6504 33.1514L24.3174 44.71L46.7295 23.374C47.94 21.7767 46.6308 19.6097 44.877 19.7832Z" fill="#42B747" stroke="white" strokeWidth="3" />
    </svg>
  );
}

export function QueueWarningStatusIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <circle cx="30.5" cy="30.5" r="29" stroke="black" strokeWidth="3" />
      <path d="M29.9736 41.2979C31.2085 41.2979 32.2759 41.7218 33.1475 42.5654H33.1484C34.0425 43.3963 34.4999 44.4294 34.5 45.6357C34.5 46.9597 34.0558 48.0515 33.1348 48.8477C32.2484 49.6139 31.2049 50 30.0264 50C28.836 50 27.7781 49.6263 26.874 48.8809L26.8652 48.874C25.9425 48.0764 25.5 46.9744 25.5 45.6357C25.5001 44.4371 25.9336 43.4062 26.79 42.5732C27.6631 41.7242 28.7347 41.2979 29.9736 41.2979ZM30.1855 10C31.8227 10 33.0554 10.5672 33.6797 11.8232H33.6787C34.2417 12.9388 34.5 14.4977 34.5 16.4502C34.5 17.5991 34.4363 18.7646 34.3115 19.9463L34.3125 19.9473L33.1738 32.6465C33.0479 34.1823 32.7749 35.4138 32.3271 36.3037C32.0883 36.7784 31.7584 37.1584 31.3301 37.416C30.9028 37.6728 30.408 37.79 29.8672 37.79C29.3233 37.79 28.8274 37.6791 28.4033 37.4316C27.9761 37.1822 27.653 36.812 27.4297 36.3467L27.4277 36.3438C27.0203 35.476 26.7495 34.2141 26.5889 32.5996L26.5869 32.584L25.7393 20.2461V20.2441C25.5803 17.8394 25.5 16.0987 25.5 15.0332C25.5001 13.5192 25.9051 12.2727 26.7783 11.3643H26.7793C27.6623 10.4471 28.8136 10 30.1855 10Z" fill="black" stroke="black" />
    </svg>
  );
}

export function QueueInfoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <circle cx="30.5" cy="30.5" r="29" stroke="white" strokeWidth="3" />
      <path d="M29.9736 41.2979C31.2085 41.2979 32.2759 41.7218 33.1475 42.5654H33.1484C34.0425 43.3963 34.4999 44.4294 34.5 45.6357C34.5 46.9597 34.0558 48.0515 33.1348 48.8477C32.2484 49.6139 31.2049 50 30.0264 50C28.836 50 27.7781 49.6263 26.874 48.8809L26.8652 48.874C25.9425 48.0764 25.5 46.9744 25.5 45.6357C25.5001 44.4371 25.9336 43.4062 26.79 42.5732C27.6631 41.7242 28.7347 41.2979 29.9736 41.2979ZM30.1855 10C31.8227 10 33.0554 10.5672 33.6797 11.8232H33.6787C34.2417 12.9388 34.5 14.4977 34.5 16.4502C34.5 17.5991 34.4363 18.7646 34.3115 19.9463L34.3125 19.9473L33.1738 32.6465C33.0479 34.1823 32.7749 35.4138 32.3271 36.3037C32.0883 36.7784 31.7584 37.1584 31.3301 37.416C30.9028 37.6728 30.408 37.79 29.8672 37.79C29.3233 37.79 28.8274 37.6791 28.4033 37.4316C27.9761 37.1822 27.653 36.812 27.4297 36.3467L27.4277 36.3438C27.0203 35.476 26.7495 34.2141 26.5889 32.5996L26.5869 32.584L25.7393 20.2461V20.2441C25.5803 17.8394 25.5 16.0987 25.5 15.0332C25.5001 13.5192 25.9051 12.2727 26.7783 11.3643H26.7793C27.6623 10.4471 28.8136 10 30.1855 10Z" fill="white" stroke="white" />
    </svg>
  );
}
